import React from 'react';
const turningCards = [{
  title: 'Ultra-Precision Turning',
  href: '/SpinnerUltraPrecisionTurning.html',
  imageSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/SPINNER/Turning%20Ultra-Precision.png800x800.png',
  imageAlt: 'Ultra-Precision Turning'
}, {
  title: 'Universal Turning',
  href: '/SpinnerUniversalTurning.html',
  imageSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/SPINNER/Universal%20Turning.png800x800.png',
  imageAlt: 'Universal Turning'
}, {
  title: 'Multi-Turret Turning',
  href: '/SpinnerMultiTurretTurning.html',
  imageSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/SPINNER/Multi-Turret%20Turning.png800x800.png',
  imageAlt: 'Multi-Turret Turning'
}];
export function TurningCentersSection() {
  return <div className="mb-20" data-id="element-3847">
      <h2 className="text-3xl font-bold text-navy mb-2" data-id="element-3848">Turning Centers</h2>
      <p className="text-gray-600 mb-8 text-lg" data-id="element-3849">
        CNC Lathes for all application types
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3850">
        {turningCards.map(card => <a key={card.title} href={card.href} className="group block bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:border-[#002d4d] hover:shadow-xl transition-all duration-300" data-id="element-3851">
            <div className="p-6 flex items-center justify-center bg-gray-50" data-id="element-3852">
              <img src={card.imageSrc} alt={card.imageAlt} className="max-w-full h-auto max-h-[280px] object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-3853" />
            </div>
            <div className="p-5 bg-white border-t border-gray-100" data-id="element-3854">
              <h3 className="text-lg font-bold text-navy text-center group-hover:text-[#002d4d] transition-colors" data-id="element-3855">
                {card.title}
              </h3>
            </div>
          </a>)}
      </div>
    </div>;
}